import { useTranslations } from "next-intl";
import { TFn } from "@/app/translations/TFn";

// Client-side translator that keeps TKey as the key: `const T = useT(); T(TKey.X)`.
// The locale is implicit (from NextIntlClientProvider), so no lang argument is needed.
// Uses t.raw() so messages are returned verbatim (no ICU parsing) — the app interpolates
// placeholders like {{value}} / {X} itself via String.replace, and braces must not be parsed.
export function useT(): TFn {
  const t = useTranslations();
  return (key) => {
    // Some callers pass a dynamic, non-TKey string (e.g. Modal renders an offer name as its
    // title). t.raw() reports MISSING_MESSAGE for those, so gate on t.has() to keep the
    // documented "unknown key falls through unchanged" fallback silent.
    if (!t.has(key)) return key;
    const value = t.raw(key);
    return typeof value === "string" ? value : key;
  };
}
